export const NAME = 'google';



// WEBPACK FOOTER //
// ./src/services/google/constants.js